import axios from "../axios"
import _ from "lodash";
//import { useDispatch } from "react-redux";
//import { logout } from "../ReduxStore/UserStore";

export const postMethod = (endPoint='',data=null)=>{
    //const dispatch = useDispatch()
    return new Promise((resolve, reject)=>{

        axios.post(endPoint,data).then((result)=>{
            resolve(result.data)

        }).catch((error)=>{
            
            if(["LOGOUT_ACCOUNT", "LOGIN_TOKEN_EXPIRED", "INVALIED_TOKEN"].indexOf(_.get(error, "response.data.detail.code",""))>-1 || _.get(error, "response.data.detail","")=="Not authenticated" ){
                //dispatch(logout())
                window.location.href = '/session-timeout';
      
            }
            reject(error?.response?.data)
            
        })

    })

}